import * as Yup from "yup";
import { CopiarOcorrenciaFormModel } from "../../../modelos/ocorrencia/copiarOcorrenciaFormModel";

export const CopiarOcorrenciaSchema: Yup.SchemaOf<CopiarOcorrenciaFormModel> =
  Yup.object().shape({
    id: Yup.string().notRequired(),
    novaData: Yup.date().required("Item obrigatório"),
    idOcorrencia: Yup.string().required("Item obrigatório"),
  });